/**
 * Created by caterina on 23-05-17.
 */
import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Http} from '@angular/http';
import {AuthenticationService} from './authentication.service';
@Injectable()
export class UserService {
    private url = `${environment.apiUrl}/user`;

    constructor(private http: Http,
                private authService: AuthenticationService) {
    }

    update(user: any) {
        return this.http.put(this.url, JSON.stringify(user), this.authService.getAuthOptions())
            .map((res) => {
                res.json();
            });
    }

    changePassword(oldPassword: string, newPassword: string) {
        const url = `${this.url}/change_password/`;
        return this.http.put(url, JSON.stringify({
            old_password: oldPassword,
            new_password: newPassword
        }), this.authService.getAuthOptions());
    }
}



// WEBPACK FOOTER //
// ./src/app/_shared/services/user.service.ts